<template>
  <div>
    <p>
      Skicka meddelande till {{customerName}} (<template v-if="isSms">{{customerPhone}}<template v-if="isEmail">, </template></template><template v-if="isEmail">{{customerEmail}}</template>):</p>

    <axios-form method="post" :action="route('quotes.vibe', quoteId)" @success="$page.alert('Ditt meddelande har skickats!'); $page.reload()" @failure="$page.alert('Något gick fel, försök igen!')">
      <div class="input-group mb-3">
        <label :for="`{uuid}-send_type`" class="input-group-prepend"><div class="input-group-text">Utskicksmetod</div></label>
        <select :id="`{uuid}-send_type`" class="custom-select" required name="send_type" v-model="selectedSendType">
          <option v-for="ast in allowedSendTypes" :key="ast.id" :value="ast.id">{{ast.label}}</option>
        </select>
      </div>
      <div v-if="isEmail" class="input-group mb-3">
        <label :for="`{uuid}-subject`" class="input-group-prepend"><div class="input-group-text">Ämnesrad för e-post</div></label>
        <input :id="`{uuid}-subject`" class="form-control" type="text" required name="subject" v-model="subject">
      </div>
      <textarea class="form-control mb-3" rows=5 maxlength=280 required name="message" v-model="message"></textarea>
      <button type="submit" class="btn btn-primary">Skicka</button>
    </axios-form>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, toRefs } from "vue";
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
const props = defineProps({
  quoteId: {
    type: Number,
    required: true
  },
  customerName: {
    type: String,
    required: true
  },
  sendType: {
    type: String,
    required: true
  },
  customerEmail: {
    type: String,
    default: null
  },
  customerPhone: {
    type: String,
    default: null
  },
  defaultSubject: {
    type: String,
    required: null
  },
  defaultMessage: {
    type: String,
    required: null
  }
});
const {
  quoteId,
  customerName,
  sendType,
  customerEmail,
  customerPhone,
  defaultSubject,
  defaultMessage
} = toRefs(props);
const emit = defineEmits(["note-added"]);
const availableSendTypes = [
  customerPhone.value && customerEmail.value ? 'dual' : null,
  customerPhone.value ? 'sms' : null,
  customerEmail.value ? 'email' : null
].filter((type): type is string => type !== null);
const selectedSendType = ref(
  availableSendTypes.includes(sendType.value)
    ? sendType.value
    : (availableSendTypes[0] ?? null)
);
const uuid = ref(uuidv4());
const subject = ref(defaultSubject.value ?? '');
const message = ref(defaultMessage.value ?? '');
const submitting = ref(false);
const note = ref(null);
const users = ref(null);
const allowedSendTypes = computed(() => {
  const types = [];
  if (customerPhone.value && customerEmail.value) {
    types.push({
      id: 'dual',
      label: 'SMS & E-post'
    });
  }
  if (customerPhone.value) {
    types.push({
      id: 'sms',
      label: 'SMS'
    });
  }
  if (customerEmail.value) {
    types.push({
      id: 'email',
      label: 'E-post'
    });
  }
  return types;
});
const isSms = computed(() => {
  return selectedSendType.value === 'sms' || selectedSendType.value === 'dual';
});
const isEmail = computed(() => {
  return selectedSendType.value === 'email' || selectedSendType.value === 'dual';
});
async function onSubmit() {
  const {
    data: newNote
  } = await axios.post(route('quote.notes.store', quoteId.value), {
    note: note.value,
    users_to_notify: users.value
  });
  emit('note-added', newNote);
  note.value = null;
  users.value = null;
}
</script>
